import api from './api'

export const productsAPI = {
  // Get all products with pagination and search
  getAll: (params = {}) => api.get('/products', { params }),
  
  // Get product by ID
  getById: (id) => api.get(`/products/${id}`),
  
  // Get product with full details (modules and features)
  getDetails: (id) => api.get(`/products/${id}/details`),
  
  // Create new product
  create: (productData) => {
    // If FormData, remove Content-Type header to let axios set it automatically with boundary
    if (productData instanceof FormData) {
      return api.post('/products', productData, {
        headers: {
          'Content-Type': undefined
        }
      })
    }
    return api.post('/products', productData)
  },
  
  // Update product
  update: (id, productData) => {
    // If FormData, remove Content-Type header to let axios set it automatically with boundary
    if (productData instanceof FormData) {
      return api.put(`/products/${id}`, productData, {
        headers: {
          'Content-Type': undefined
        }
      })
    }
    return api.put(`/products/${id}`, productData)
  },
  
  // Delete product
  delete: (id) => api.delete(`/products/${id}`),
  
  // Check if product can be deleted
  checkDeletion: (id) => api.get(`/products/${id}/check-deletion`),
  
  // Calculate product pricing
  calculatePricing: (id, userCount) => api.post(`/products/${id}/pricing`, { user_count: userCount }),
  
  // Product Modules Management
  getModules: (productId) => api.get(`/products/${productId}/modules`),
  createModule: (productId, moduleData) => api.post(`/products/${productId}/modules`, moduleData),
  updateModule: (moduleId, moduleData) => api.put(`/products/modules/${moduleId}`, moduleData),
  deleteModule: (moduleId) => api.delete(`/products/modules/${moduleId}`),

  // Product Roles Management (supports external API)
  getRoles: (productId) => api.get(`/products/${productId}/roles`),
  
  // Product Features Management
  getFeatures: (productId) => api.get(`/products/${productId}/features`),
  createFeature: (productId, featureData) => api.post(`/products/${productId}/features`, featureData),
  updateFeature: (featureId, featureData) => api.put(`/products/features/${featureId}`, featureData),
  deleteFeature: (featureId) => api.delete(`/products/features/${featureId}`),

  // Product Config Management
  getConfig: (productId) => api.get(`/products/${productId}/config`),
  getAllConfigs: (productId) => api.get(`/products/${productId}/configs`),
  createConfig: (productId, configData) => api.post(`/products/${productId}/config`, configData),
  updateConfig: (productId, configData) => api.put(`/products/${productId}/config`, configData),
  updateConfigById: (productId, configId, configData) => api.put(`/products/${productId}/config/${configId}`, configData),
  deleteConfig: (productId) => api.delete(`/products/${productId}/config`),
  deleteConfigById: (productId, configId) => api.delete(`/products/${productId}/config/${configId}`),
  // deleteFeature: (featureId) => api.delete(`/products/features/${featureId}`),
  
  // Hub Permissions Management (features where product_id is null)
  getHubPermissions: () => api.get('/products/hub/permissions'),
  createHubPermission: (permissionData) => api.post('/products/hub/permissions', permissionData),

  // Payment Details Management
  getPaymentDetails: (productId) => api.get(`/products/${productId}/payment-details`),
  createPaymentDetail: (productId, paymentData) => api.post(`/products/${productId}/payment-details`, paymentData),
  updatePaymentDetail: (paymentDetailId, paymentData) => api.put(`/products/payment-details/${paymentDetailId}`, paymentData),
  deletePaymentDetail: (paymentDetailId) => api.delete(`/products/payment-details/${paymentDetailId}`)
}

export default productsAPI
